<mat-form-field class="search-bar" floatLabel="never" appearance="outline">
  <mat-icon matPrefix>search</mat-icon>
  <input #searchInput (input)="onInput(searchInput.value)" matInput placeholder="Search" aria-label="Search"/>
  <mat-icon *ngIf="!!searchInput.value" matSuffix
    (click)="onInput(''); searchInput.value=''" class="close-icon">close</mat-icon>
</mat-form-field>
